import 'scss/solutions/ai-data-resource.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/ai-data-resource.js